"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateGetSetRemove = exports.keepCrossWindowLocalStorageParity = void 0;
const post_message_1 = require("../post-message");
/**
 * Use window `postMessage` communication to communicate
 * `localStorage` value intent. Note this must be invoked
 * from the child window, as it attempts to communicate
 * to any parent/opener windows.
 *
 * Necessary for some coordinated behaviour between
 * @launcher and @client packages.
 */
const keepCrossWindowLocalStorageParity = function (key) {
  let value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  (0, post_message_1.sendPostMessage)({
    msgKey: post_message_1.MSG_KEYS.CROSS_WINDOW_LOCALSTORAGE,
    payload: {
      key,
      value
    }
  });
};
exports.keepCrossWindowLocalStorageParity = keepCrossWindowLocalStorageParity;
/**
 * Generate get/set/remove functions for managing
 * individual localStorage items and their values.
 */
const generateGetSetRemove = _ref => {
  let {
    key,
    crossWindow = false
  } = _ref;
  const safeLocalStorage = typeof window !== "undefined" ? window.localStorage : undefined;
  const getFn = () => {
    return safeLocalStorage === null || safeLocalStorage === void 0 ? void 0 : safeLocalStorage.getItem(key);
  };
  const setFn = value => {
    safeLocalStorage === null || safeLocalStorage === void 0 ? void 0 : safeLocalStorage.setItem(key, value);
    if (crossWindow) (0, exports.keepCrossWindowLocalStorageParity)(key, value);
  };
  const removeFn = () => {
    safeLocalStorage === null || safeLocalStorage === void 0 ? void 0 : safeLocalStorage.removeItem(key);
    if (crossWindow) (0, exports.keepCrossWindowLocalStorageParity)(key);
  };
  return [getFn, setFn, removeFn];
};
exports.generateGetSetRemove = generateGetSetRemove;